module.exports = __webpack_public_path__ + "media/images/stanford_channels_landing-445be1944127f91dc725718baca860d0.png";